import { useTranslation } from "react-i18next";

export const useTranslateConstants = () => {
  const { t } = useTranslation();

  const internalReasonCancel = [
    {
      id: "1",
      label: t("selectAnOption"),
      value: "",
    },
    {
      id: "2",
      label: t("notApplicable"),
      value: "N/A",
    },
    {
      id: "3",
      label: t("damaged"),
      value: "DAMAGED",
    },
    {
      id: "4",
      label: t("incorrectVr"),
      value: "INCORRECT_VR",
    },
    {
      id: "5",
      label: t("incorrectWorkorder"),
      value: "INCORRECT_WORK_ORDER",
    },
    {
      id: "6",
      label: t("late"),
      value: "LATE",
    },
    {
      id: "7",
      label: t("missedTheVan"),
      value: "MISSED_THE_VAN",
    },
    {
      id: "8",
      label: t("missing"),
      value: "MISSING",
    },
    {
      id: "9",
      label: t("productIncomplete"),
      value: "PRODUCT_INCOMPLETE",
    },
    {
      id: "10",
      label: t("taggedWrong"),
      value: "TAGGED_WRONG",
    },
  ];

  const shopifyCancelReason = [
    {
      id: "1",
      label: t("customer"),
      value: "CUSTOMER",
    },
    {
      id: "2",
      label: t("declined"),
      value: "DECLINED",
    },
    {
      id: "3",
      label: t("fraud"),
      value: "FRAUD",
    },
    {
      id: "4",
      label: t("inventory"),
      value: "INVENTORY",
    },
    {
      id: "5",
      label: t("other"),
      value: "OTHER",
    },
    {
      id: "6",
      label: t("staff"),
      value: "STAFF",
    },
  ];

  const ebayCancelReason = [
    {
      id: "1",
      label: t("addressIssues"),
      value: "ADDRESS_ISSUES",
    },
    {
      id: "2",
      label: t("buyerAskedCancel"),
      value: "BUYER_ASKED_CANCEL",
    },
    {
      id: "3",
      label: t("orderUnpaid"),
      value: "ORDER_UNPAID",
    },
    {
      id: "4",
      label: t("outOfStockOrCannotFulfill"),
      value: "OUT_OF_STOCK_OR_CANNOT_FULFILL",
    },
    {
      id: "5",
      label: t("unknown"),
      value: "UNKNOWN",
    },
  ];

  const refundReason = [
    {
      id: "1",
      label: t("customer"),
      value: "customer",
    },
    {
      id: "2",
      label: t("damage"),
      value: "damage",
    },
    {
      id: "3",
      label: t("restock"),
      value: "restock",
    },
    {
      id: "4",
      label: t("other"),
      value: "other",
    },
  ];

  const refundPercentage = [
    {
      id: "1",
      label: "100%",
      value: "100%",
    },
    {
      id: "2",
      label: "90%",
      value: "90%",
    },
    {
      id: "3",
      label: "80%",
      value: "80%",
    },
    {
      id: "4",
      label: "70%",
      value: "70%",
    },
    {
      id: "5",
      label: "60%",
      value: "60%",
    },
    {
      id: "6",
      label: "50%",
      value: "50%",
    },
  ];

  const stockLocationInitialValue = [
    {
      id: "63647232c09b1fa35103bec6",
      tenantName: "Incycle",
      name: t("pomonaFulfillmentCenter"),
      code: "9",
    },
  ];

  const refundCondition = [
    {
      id: "1",
      label: t("new"),
      value: "New",
    },
    {
      id: "2",
      label: t("blem"),
      value: "Blem",
    },
    {
      id: "3",
      label: t("missingParts"),
      value: "Missing Parts",
    },
    {
      id: "4",
      label: t("noBox"),
      value: "No Box",
    },
    {
      id: "5",
      label: t("openBox"),
      value: "Open Box",
    },
    {
      id: "6",
      label: t("preOwned"),
      value: "Pre-Owned",
    },
    {
      id: "7",
      label: t("takeOff"),
      value: "Take-Off",
    },
  ];

  const ebayRefundReason = [
    {
      id: "1",
      label: t("buyerCancel"),
      value: "BUYER_CANCEL",
    },
    {
      id: "2",
      label: t("itemNotReceived"),
      value: "ITEM_NOT_RECEIVED",
    },
    {
      id: "3",
      label: t("sellerCancel"),
      value: "SELLER_CANCEL",
    },
  ];

  const internalReasonRefund = [
    {
      id: "1",
      label: t("selectAnOption"),
      value: "",
    },
    {
      id: "2",
      label: t("notApplicable"),
      value: "N/A",
    },
    {
      id: "3",
      label: t("damaged"),
      value: "DAMAGED",
    },
    {
      id: "4",
      label: t("incorrectVr"),
      value: "INCORRECT_VR",
    },
    {
      id: "5",
      label: t("incorrectWorkorder"),
      value: "INCORRECT_WORK_ORDER",
    },
    {
      id: "6",
      label: t("late"),
      value: "LATE",
    },
    {
      id: "7",
      label: t("missedTheVan"),
      value: "MISSED_THE_VAN",
    },
    {
      id: "8",
      label: t("missing"),
      value: "MISSING",
    },
    {
      id: "9",
      label: t("productIncomplete"),
      value: "PRODUCT_INCOMPLETE",
    },
    {
      id: "10",
      label: t("taggedWrong"),
      value: "TAGGED_WRONG",
    },
  ];

  return {
    internalReasonCancel,
    shopifyCancelReason,
    ebayCancelReason,
    refundReason,
    refundPercentage,
    stockLocationInitialValue,
    refundCondition,
    ebayRefundReason,
    internalReasonRefund,
  };
};
